import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  url: any;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authenticationService.getStatus().pipe(
      switchMap((status) => {
        if (!status) {
          return of(this.router.createUrlTree(['']));
        }

        // Traemos el usuario completo con su rol
        return this.authenticationService.getUserByUid(status.uid).pipe(
          map((userDocs) => {
            if (userDocs.length === 0) {
              // Usuario no existe en la colección
              return this.router.createUrlTree(['']);
            }

            const user:any = userDocs[0]; // { uid, rol: 'admin' | 'externo' | 'otro' }
            const requestedUrl = state.url;

            // Lógica de acceso
            if (user.rol === 'admin') {
              // Si ya está en /admin o subrutas → permitir
              if (requestedUrl.startsWith('/admin')) {
                return true;
              }
              // Si intenta otra ruta → redirigir a /admin
              return this.router.createUrlTree(['/admin']);
            }
            if (user.rol === 'padre') {
              if (requestedUrl.startsWith('/padres')) {
                return true;
              }
              return this.router.createUrlTree(['/padres']);
            }

            if (user.rol === 'externo') {
              if (requestedUrl.startsWith('/externo')) {
                return true;
              }
              return this.router.createUrlTree(['/externo']);
            }

            // Rol normal → dashboard
            if (requestedUrl.startsWith('/dashboard')) {
              return true;
            }
            return this.router.createUrlTree(['/dashboard']);
          })
        );
      })
    );
  }
}
